import { NgClass } from "@angular/common";
import {
    Component,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { IToastItem, ToastService } from "./toast.service";

@Component({
    selector: "rask-toast",
    styleUrls: ["./toast.component.scss"],
    templateUrl: "./toast.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class ToastComponent implements OnInit, OnDestroy {
    protected toasts: IToastItem[] = [];

    private readonly destroy$ = new Subject<void>();
    private readonly toastService = inject(ToastService);

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngOnInit() {
        this.toastService.trigger.pipe(
            takeUntil(this.destroy$)
        ).subscribe(toast => {
            this.toasts.push(toast);

            setTimeout(() => {
                this.remove(toast);
            }, toast.delay);
        });
    }

    protected remove(toast: IToastItem) {
        this.toasts = this.toasts.filter(t => t !== toast);
    }
}
